export const MARKETS_URL = "/markets";
export const SIGNUP_URL = "/#access";
export const ORIGINAL_MARKETS_URL = "/markets";
